export const isProduction = true;
export const isStaging = false;
export const imageBasePath =
  process.env.NODE_ENV === "production" ? "/business/images" : "/images";
export const appBasePath =
  process.env.NODE_ENV === "production" ? "/business" : "";
  export const phoneNumber = "+971543040110";
// export const googleClientId = '325191651728-3luk3tuh4h0in6svqoh0d74gkkdbb5f5.apps.googleusercontent.com';
export const gtmId = isProduction ? "GTM-MMR37VC" : isStaging ? "GTM-57WMLZ6" : "";

export const googleClientId = isProduction
  ? "72058500133-8n0c0t2ev4vpfl4aieijqaifor6l5rf3.apps.googleusercontent.com" :
  isStaging ? "805145423813-tv0khgomiape69eaei4ngrp8op618dfu.apps.googleusercontent.com"
  : "325191651728-3luk3tuh4h0in6svqoh0d74gkkdbb5f5.apps.googleusercontent.com";
export const fbAppId = isProduction ? "2146640298685254" : "1931777803704298";
export const canonicalLink = "https://carcility.com/";
export const serviceTypes = [
  {
    name: "Wash",
    className: "wash",
    serviceImage: imageBasePath + "/wash.png",
    hyperlink: ""
  },
  {
    name: "Servicing",
    className: "servicing",
    serviceImage: imageBasePath + "/service.png",
    hyperlink: ""
  },
  {
    name: "Repair",
    className: "repair",
    serviceImage: imageBasePath + "/repair.png",
    hyperlink: ""
  },
  {
    name: "Emergency Service",
    className: "emergency",
    serviceImage: imageBasePath + "/emergency.png",
    hyperlink: ""
  }
];

export const validationMessage = {
  email: {
    emptyError: "Please enter your email id",
    validationError: "Enter a valid email id"
  },
  password: {
    emptyError: "Password cannot be empty",
    validationError: "Password should be greater than five digits"
  },
  name: {
    emptyError: "Name cannot be empty",
    validationError: "Enter your name"
  },
  phone: {
    emptyError: "Please enter your mobile number",
    validationError: "Enter a valid mobile number"
  },
  otp: {
    emptyError: "Enter your OTP to continue",
    validationError: "Please a valid OTP number"
  },
  website: {
    emptyError: "Website cannot be empty",
    validationError: "Please enter the correct website"
  },
  address: {
    emptyError: "Address cannot be empty",
    validationError: "Please enter the Address"
  },
  company: {
    emptyError: "Company Name cannot be empty",
    validationError: "Please enter the Company Name"
  },
  promotiontext: {
    emptyError: "Promotion Text cannot be empty",
    validationError: "Please enter the Promotion Text"
  },
  companyregistrationnumber: {
    emptyError: "Company Registration Number cannot be empty",
    validationError: "Please enter Company Registration Number"
  },
  quoteAmount: {
    emptyError: "Quote amount cannot be empty",
    validationError: "Please enter valid quote amount"
  }
};

export const jobServiceStatuses = {
  6: {
    id: 6,
    displayname: "Pending"
  },
  3: {
    id: 3,
    displayname: "In Progress"
  },
  7: {
    id: 7,
    displayname: "Completed"
  }
};

export const services = {
  1: "wash",
  2: "repair",
  3: "service",
  4: "emergency service"
};

export const metaTagData = {
  "signin-as": {
    title: "List your car care business | Register your business with Carcility",
    headLink: "signin-as",
    description:
      "Grow your Car Repair Services in Dubai with the help of Carcility. The platform instantly connect nearby customers in need of auto service with car service providers ."
  },
  "signup-as": {
    title: "Sign Up For Business |Partner with us for your car service business - Carcility",
    headLink: "signup-as",
    description:
      "Sign up with Carcility and become the best Auto Service provider in Dubai. Get easy promotion for your car repair shops. No paperwork and unwanted spends."
  },
  "contact-us": {
    title: "Contact Us | Carcility",
    headLink: "contact",
    description:
      "Contact Carcility for any query about Car Repair services in Dubai.  ✓ Call or Email about car service shops ✓ Service available 24 X 7"
  },
  "business-landing": {
    title: "List your car service business | Register your business with Carcility",
    headLink: 'business-landing',
    description:
      "Grow your Auto Services business in Dubai with Carcility. List your business, Receive service requests, Send quotes and Get paid fast. No paperwork and unwanted spends.Start now!"
  },
  faq: {
    title: "FAQ - Carcility",
    headLink: "blog/faq",
    description:
      "Everything you need to know for getting car repair services or providing Auto Services in Dubai through Carcility. Read the FAQ properly to know about this car maintenance platform."
  },
  terms: {
    title: "Terms & Conditions | Carcility",
    headLink: "terms",
    description: "These Car Repair Terms and Conditions are designed for use by businesses and customers for providing repair services for a variety of vehicles.  This document is also suitable for the provision of routine and non-routine maintenance."
  },
  "sign-up": {
    title: "Sign Up For Businesses |  Partner with us or Join us - Carcility",
    headLink: "sign-up",
    description:
      "Provide your premium quality car services and diagnostics to potential car owners in Dubai. ✓ Get Fast growth ✓ Build trust ✓ Automate Services. Join Carcility today."
  },
  "sign-in": {
    title: "List your car care business | Register your business with Carcility",
    headLink: "sign-in",
    description:
      "Grow your Auto Repair Services in Dubai with the help of Carcility. ✓ Easy promotion for car repair shops ✓ The platform automatically matches customers with qualified service providers in the vicinity ✓ No paperwork, hassle or unwanted spends for businesses"
  }
};



// WEBPACK FOOTER //
// ./src/constants/staticData.js